/* eslint-disable react/forbid-elements */
import * as React from 'react';
import { IRating } from '../../types/developer/ratings';
import { getArcs, IArcSettings } from './helpers';
import { ARC_START_COORDINATES, ARC_STROKE_WIDTH, CHART_WIDTH } from '../../constants';

interface IPieChartProps {
  data: IRating;
  settings?: IArcSettings;
}

const defaultSettings = {
  width: CHART_WIDTH,
  strokeWidth: ARC_STROKE_WIDTH,
  startCoordinates: ARC_START_COORDINATES,
};

export function PieChart({ data, settings = defaultSettings }: IPieChartProps) {
  const arcs = React.useMemo(() => getArcs(data, settings), [data, settings]);

  return (
    <svg width={settings.width} height={settings.width}>
      {arcs.map((item, index) => (
        <path key={index} fill={item.fill} stroke={item.stroke} strokeWidth={item.strokeWidth} d={item.d} />
      ))}
    </svg>
  );
}
